import { Box } from "@mui/material";
import SelectBusinessAccount from "../../../../Meta/SelectBusinessAccount";
import { LINKEDIN } from "../../../../../utils/constants";
import {
  FIELD_REQUIRED,
  LINKEDIN_ACCOUNT_SHARE_PLACEHOLDER,
} from "../../../../../i18n/keysTranslations";

const LinkedInPlatformFields = ({
  control,
  errors,
  t,
  onChangeAccount,
  disableAutoSelect = false,
  disabled = false,
  restrictToCampaignAdvertiserPages = false,
  campaignIntegrationID = "",
  campaignAdvertiserID = "",
}) => {
  return (
    <Box
      sx={{ display: "flex", flexDirection: "column", gap: 2, width: "100%" }}
    >
      <SelectBusinessAccount
        variant="filled"
        name="platformsData.linkedIn.account"
        label={t(LINKEDIN_ACCOUNT_SHARE_PLACEHOLDER)}
        fullWidth={true}
        control={control}
        platform={LINKEDIN}
        errors={errors}
        onChangeAction={onChangeAccount}
        linkedInForPublishing={true}
        linkedInRestrictToCampaignAdvertiserPages={
          restrictToCampaignAdvertiserPages
        }
        linkedInCampaignIntegrationID={campaignIntegrationID}
        linkedInCampaignAdvertiserID={campaignAdvertiserID}
        disableAutoSelect={disableAutoSelect}
        disabled={disabled}
        rules={{
          required: {
            value: true,
            message: t(FIELD_REQUIRED),
          },
        }}
      />
    </Box>
  );
};

export default LinkedInPlatformFields;
